import { useQuestionnaireContext } from '../context/QuestionnaireContext';

/**
 * Hook that determines if the questionnaire is ready to accept answer submissions.
 * Returns false during loading, session initialization, or when no responseId exists.
 */
export function useCanSubmit(): boolean {
  const { state } = useQuestionnaireContext();
  return !state.isLoading && !state.isInitializingSession && !!state.responseId;
}